import React, { useContext } from 'react';
import SectionBlock from './SectionBlock';
import { IconWalkingL } from '../../../icons';
import { MatchingDialogContext } from '../configs';
import {
    resolveMobilityDescriptionHorse,
    resolveMobilityDescriptionRider,
    showSection,
} from '../utils';
import config from '../../../config';
import { useIntl } from 'react-intl';
import { trimDisplayNameLastWord } from '../../../util/text';

const {
    listingTypeHorse,
    listingTypeRider,
    listingTypePrivateHorse,
    listingTypePrivateRider,
} = config;

const SectionMobility = () => {
    const intl = useIntl();
    const { scoreData, categorySelected, currentPageListing, currentUser } = useContext(
        MatchingDialogContext
    );
    const scoreLocationData = scoreData?.baseScoreBreakdown?.distanceAndMobilityScore;

    if (!scoreLocationData) return null;
    const { mobilityScore } = scoreLocationData || {};
    const mobilityScoreData = { maxScore: 5, total: mobilityScore };

    const { title, publicData } = currentPageListing?.attributes || {};
    const { type } = publicData || {};

    const isHorseListing = type === listingTypeHorse || type === listingTypePrivateHorse;
    const isRiderListing = type === listingTypeRider || type === listingTypePrivateRider;

    const transport = isHorseListing
        ? currentUser?.attributes?.profile?.publicData?.mobility?.transport
        : currentPageListing?.attributes?.publicData?.mobility?.transport;

    if (!transport) return null;

    const transportFormatted = intl.formatMessage({
        id: `EditUserMobilitySection.mobility-${transport}`,
    });

    const { isHighScore, isLowScore, shouldBeShown } = showSection({
        categorySelected,
        ...mobilityScoreData,
    });

    if (!shouldBeShown) return null;

    const descriptionResolver = isHorseListing
        ? resolveMobilityDescriptionRider
        : resolveMobilityDescriptionHorse;

    const description = descriptionResolver({
        isHighScore,
        isLowScore,
        title: isRiderListing ? trimDisplayNameLastWord(title) : title,
        transport: transportFormatted,
    });

    return (
        <SectionBlock scoreData={scoreData}>
            <SectionBlock.Header>
                <IconWalkingL />
                <span>Mobilität</span>
            </SectionBlock.Header>
            <SectionBlock.ScoreBadge sectionScoreData={mobilityScoreData} />
            <SectionBlock.Description>{description}</SectionBlock.Description>
        </SectionBlock>
    );
};

export default SectionMobility;
